import { useRegDetail } from "shared/context/regDetail";
import { getFormattedCurrency } from "shared/utils";
import Button from "shared/components/button";
import { TicketUpgradeCardPropsType } from "./type";
import { useCopies } from "shared/hooks/useCopies";
import React from "react";
import Icon from "assets/icons";
import ReadMore from "shared/components/readMore";
import { ComposedIcons } from "assets/icons/icons.compose";
import PrivilegesList from "./privilegesList";
import useTicketUpgradeCardService from "./service";

export default function TicketUpgradeCard(props: TicketUpgradeCardPropsType) {
  const { localeId } = useRegDetail();
  const copies = useCopies();
  const service = useTicketUpgradeCardService(props);

  return (
    <div className="ticketUpgradeCard">
      <div className="ticketUpgradeCard_headerBorder">
        <ComposedIcons.TicketBorder />
      </div>
      <div className="ticketUpgradeCard_header">
        <div className="ticketUpgradeCard_headerContent">
          <h2 className="ticketUpgradeCard_headerContent--title" title={props.ticketDetails.title}>
            {props.ticketDetails.title}
          </h2>
        </div>
      </div>
      <div className="ticketUpgradeCard_rip">
        <div className="ticketUpgradeCard_rip--border"></div>
      </div>
      <div className="ticketUpgradeCard_body">
        <div className="ticketUpgradeCard_bodyContent">
          <div className="ticketUpgradeCard_bodyContent--desc">
            {props.ticketDetails.ticketDescription && (
              <ReadMore content={props.ticketDetails.ticketDescription} isHTMLFormatted />
            )}
          </div>
          <div className="ticketUpgradeCard_bodyContent--privilegesList">
            {props.ticketDetails.accessPrivileges && props.ticketDetails.accessPrivileges.length > 0 ? (
              <PrivilegesList
                accessPrivileges={props.ticketDetails.accessPrivileges}
                existingPrivileges={props.currentTicketDetails.accessPrivileges || []}
              />
            ) : (
              !service.isCurrentTicket && (
                <div className="noPrivilegesView">
                  <div className="noPrivilegesView_chatBubble">
                    <p className="noPrivilegesView_chatBubble--label">
                      {copies.get("ticket.change.privilege.not.available.label")}
                    </p>
                  </div>
                  <div className="noPrivilegesView_chatNotch">
                    <Icon.ChatBoxNotch />
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
      {!service.isCurrentTicket && (
        <div className="ticketUpgradeCard_footer">
          <div className="ticketUpgradeCard_footerPriceWrapper">
            {/* Intentionally commented */}
            {/* <div className="ticketUpgradeCard_footerPriceWrapper--label">{copies.get("ticket.change.label")}:</div> */}
            <div className="ticketUpgradeCard_footerPriceWrapper--price">
              {props.ticketDetails.currentPrice && service.hasPriceDifference && (
                <div className="ticketUpgradeCard_footerPriceWrapper--priceAmount">
                  {getFormattedCurrency(props.ticketDetails.currentPrice, localeId)}
                </div>
              )}
              {props.ticketDetails.priceDifference && (
                <div className="ticketUpgradeCard_footerPriceWrapper--priceToPay">
                  {getFormattedCurrency(props.ticketDetails.priceDifference, localeId)}
                </div>
              )}
            </div>
          </div>
          <div className="ticketUpgradeCard_footerPriceWrapper--action">
            {!service.isCurrentTicket && (
              <Button
                isOutline
                onClick={service.buyTicketClickHandler}
                label={copies.get("buy.now")}
                icon={<Icon.ArrowRightLong />}
                iconPositionRight
              />
            )}
          </div>
        </div>
      )}
      <div className="ticketUpgradeCard_footerBorder">
        <ComposedIcons.TicketBorder />
      </div>
    </div>
  );
}
